import pushTo from "./pushTo";

export default function fromIterator(iterate){
	const array = [];
	iterate(pushTo(array));
	return array;
}
